export default __webpack_public_path__ + "static/2-science-fiction-8f01a39a0080384a98215c22328a003c.png";